const GENAI_CATEGORIES_HAIR = [
    { id: 'cat130038', name: 'hair' },
    { id: 'cat1910033', name: 'travelSizeHair' },
    { id: 'cat1080043', name: 'dryersHairTools' },
    { id: 'cat1200068', name: 'hairMist' },
    { id: 'cat1220035', name: 'mensHair' },
    { id: 'cat1230059', name: 'mensHairCare' },
    { id: 'cat1960037', name: 'cleanHair' },
    { id: 'cat60119', name: 'hairRemoval' }
];

const GENAI_CATEGORIES_SKINCARE = [
    { id: 'cat150006', name: 'skincare' },
    { id: 'cat1960033', name: 'cleanSkincare' },
    { id: 'cat5000015', name: 'luxurySkincare' },
    { id: 'cat1230058', name: 'mensFacialSkincare' },
    { id: 'cat1910031', name: 'travelSizeSkincare' }
];

const GENAI_CATEGORIES_FRAGRANCE = [
    { id: 'cat160006', name: 'fragrance' },
    { id: 'cat1230057', name: 'mensPerfume' },
    { id: 'cat1910032', name: 'travelSizeFragrance' },
    { id: 'cat1960031', name: 'cleanFragrance' }
];

const GENAI_CATEGORIES_MAKEUP = [
    { id: 'cat140006', name: 'makeup' },
    { id: 'cat1910030', name: 'travelSizeMakeup' },
    { id: 'cat1960035', name: 'cleanMakeup' },
    { id: 'cat5000014', name: 'luxuryMakeup' },
    { id: 'cat1210031', name: 'makeupRemover' }
];

const GENAI_CATEGORIES_TOOLS_AND_BRUSHES = [{ id: 'cat130042', name: 'toolsAndBrushes' }];

const GENAI_CATEGORIES_BATH_AND_BODY = [{ id: 'cat140014', name: 'bathAndBody' }];

export default {
    GENAI_CATEGORIES_HAIR,
    GENAI_CATEGORIES_SKINCARE,
    GENAI_CATEGORIES_FRAGRANCE,
    GENAI_CATEGORIES_MAKEUP,
    GENAI_CATEGORIES_TOOLS_AND_BRUSHES,
    GENAI_CATEGORIES_BATH_AND_BODY
};
